var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('img',{staticClass:"w-[150px] m-auto",attrs:{"src":"/Husqvarna-Logo.png"}})])
}]

export { render, staticRenderFns }